export const GET_LOG_GENERAL_WHATSAPP_START = 'GET_LOG_ENTREGAS_WHATSAPP_START';
export const GET_LOG_GENERAL_WHATSAPP_ERROR = 'GET_LOG_ENTREGAS_WHATSAPP_ERROR';
export const GET_LOG_GENERAL_WHATSAPP_SUCCESS = 'GET_LOG_ENTREGAS_WHATSAPP_SUCCESS';

export const SET_FILTER_PARAMS = 'SET_FILTER_PARAMS';
export const RESET_LOG_WHATSAPP_STATE = 'RESET_LOG_WHATSAPP_STATE';